import { createSelector } from 'reselect';

const getSelection = state => state.quotes_page.selection;

export const selectSelectedIds = createSelector(
  getSelection,
  (ids) => ids || []
);
